type StrikeDiagonalProps = {
  children: React.ReactNode;
  lineColor?: string;
  lineWidth?: number;
  lineLengthPercentage?: number;
};

export const StrikeDiagonal = ({
  children,
  lineColor = "#000",
  lineWidth = 1,
  lineLengthPercentage = 80,
}: StrikeDiagonalProps) => {
  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      {children}
      <svg
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          pointerEvents: "none",
        }}
      >
        <line
          x1={100 - lineLengthPercentage}
          y1={lineLengthPercentage}
          x2={lineLengthPercentage}
          y2={100 - lineLengthPercentage}
          stroke={lineColor}
          strokeWidth={lineWidth}
          vectorEffect="non-scaling-stroke"
        />
      </svg>
    </div>
  );
};
